var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.386 14.386l4.0877 4.0877-4.0877-4.0877c-2.9418 2.9419-7.7115 2.9419-10.6533 0-2.9419-2.9418-2.9419-7.7115 0-10.6533 2.9418-2.9419 7.7115-2.9419 10.6533 0 2.9419 2.9418 2.9419 7.7115 0 10.6533z","strokeWidth":"2","stroke":"currentColor","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Search.defaultProps = {"viewBox":"0 0 20 20"};

module.exports = Search;

Search.default = Search;
